import { BaseModel } from "sjs-base-model";
import { bool } from "yup";

export default class ActivityTypeModel extends BaseModel {
  _shards = {};
  current_page_no = 0;
  hits = {};
  timed_out = bool;
  took = 0;
  total_page_no = 0;

  constructor(data1) {
    super();

    this.update(data1);
  }
}
